module.exports = __webpack_public_path__ + "static/media/fe83f850-c96c-4750-8b5c-649290dd55c3.9ce91af7.png";